module.exports = __webpack_public_path__ + "static/media/investor-icon.aeff6963.svg";